import { useMemo, type FC } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { SocialProofText } from './social-proof-text/social-proof-text';
import * as Styled from './social-proof.styles';

export const SocialProof: FC = () => {
  const { pageContext } = usePageContext();

  const socialProof = pageContext.socialProof;

  const socialProofData = useMemo(() => {
    if (!socialProof) return undefined;

    const userNodes = socialProof.edges;
    const users = userNodes?.map((user) => user?.node?.xingId) ?? undefined;

    return {
      users: users?.map((user) => ({
        id: user?.id,
        profileName: user?.displayName,
        src: user?.profileImage?.[0]?.url,
        href:
          user?.clickReasonProfileUrl?.profileUrl ||
          `/profile/${user?.pageName}`,
      })),
      total: socialProof.total,
      proofType: socialProof.proofType,
    };
  }, [socialProof]);

  if (!socialProofData || socialProofData.total === 0) {
    return null;
  }

  return (
    <div data-testid="social-proof">
      <Styled.SocialProofWrapper>
        <Styled.ImagesWrapper>
          <Styled.SocialProofImages
            // @ts-expect-error TODO: fix this type
            actors={socialProofData.users.slice(0, 3)}
            maxActors={3}
            size="small"
            sizeWide="medium"
          />
        </Styled.ImagesWrapper>
        <Styled.ContactsWrapper size={'small'}>
          {socialProofData.users && socialProofData.proofType ? (
            <SocialProofText
              // @ts-expect-error TODO: fix this type
              users={socialProofData.users}
              total={socialProofData.total}
              proofType={socialProofData.proofType}
            />
          ) : null}
        </Styled.ContactsWrapper>
      </Styled.SocialProofWrapper>
    </div>
  );
};
